// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product__video__slider{display:none}.product-typography-video{margin-top:24px;margin-bottom:24px}.product-typography-video .c-slider__swiper{border-radius:var(--13d0htc)}.product-typography-video__title{font-weight:700;font-size:19px;line-height:24px;margin-bottom:16px}", ""]);
// Exports
module.exports = exports;
